import { useStore } from '../Store/storeProvider';
import Me from '../Services/UsuarioService';
import useMeHandler from "./useMeHandler";
import useLogout from '../Services/_LogoutService';
import { trackCustomEvent } from "../Config/DataDog";
import { deleteCallbackEmailVerification, getCallbackEmailVerification } from '../Helpers/Auth0StorageManager';

const useLoginAuth0Handler = () => {
    const { Config, User } = useStore();
    const [MeHandler] = useMeHandler();
    const handleLogout = useLogout();

    const loginAuth0Handler = async () => {
        try {
            let userCallbackEmailVerification = getCallbackEmailVerification();
            if (userCallbackEmailVerification == null) {
                userCallbackEmailVerification = Config.URLCallback
            } else {
                deleteCallbackEmailVerification();
            }
            const responseMe = await Me();
            await MeHandler(responseMe, User, userCallbackEmailVerification);
        } catch (error) {
            trackCustomEvent("logout", true, { message: `useLoginAuth0Handler - ${error.message}` })
            handleLogout();
        }
    };
    return [loginAuth0Handler];
};
export default useLoginAuth0Handler;